// GST tax calculation logic
// If business state == customer state → CGST + SGST (split equally)
// If business state != customer state → IGST (full rate)

export function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function calculateLineItem(li) {
  const qty = Number(li.qty) || 0;
  const rate = Number(li.rate) || 0;
  const discount = Number(li.discount) || 0;
  const gstRate = Number(li.gstRate) || 0;
  const gross = qty * rate;
  const discountAmt = gross * (discount / 100);
  const taxableAmount = gross - discountAmt;
  const gstAmount = taxableAmount * (gstRate / 100);
  return { taxableAmount: round2(taxableAmount), gstAmount: round2(gstAmount) };
}

export function calculateInvoice(lineItems, businessStateShort, customerStateShort) {
  const isInterState = Boolean(businessStateShort) && Boolean(customerStateShort) && businessStateShort !== customerStateShort;
  let subtotal = 0;
  let totalDiscount = 0;
  let taxableAmount = 0;
  let cgst = 0;
  let sgst = 0;
  let igst = 0;
  const enriched = [];
  for (const li of lineItems) {
    const qty = Number(li.qty) || 0;
    const rate = Number(li.rate) || 0;
    const discount = Number(li.discount) || 0;
    const gstRate = Number(li.gstRate) || 0;
    const gross = qty * rate;
    const discountAmt = gross * (discount / 100);
    const taxable = gross - discountAmt;
    const gstAmount = taxable * (gstRate / 100);
    subtotal += gross;
    totalDiscount += discountAmt;
    taxableAmount += taxable;
    let liCgst = 0, liSgst = 0, liIgst = 0;
    if (isInterState) {
      liIgst = gstAmount;
      igst += liIgst;
    } else {
      liCgst = gstAmount / 2;
      liSgst = gstAmount / 2;
      cgst += liCgst;
      sgst += liSgst;
    }
    enriched.push({
      ...li,
      taxableAmount: round2(taxable),
      cgst: round2(liCgst),
      sgst: round2(liSgst),
      igst: round2(liIgst),
      total: round2(taxable + gstAmount),
    });
  }
  const grandTotal = taxableAmount + cgst + sgst + igst;
  return {
    lineItems: enriched,
    taxSummary: {
      subtotal: round2(subtotal),
      totalDiscount: round2(totalDiscount),
      taxableAmount: round2(taxableAmount),
      cgst: round2(cgst),
      sgst: round2(sgst),
      igst: round2(igst),
      grandTotal: round2(grandTotal),
      isInterState,
    },
  };
}

export function formatINR(n) {
  return '\u20B9' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
